// Role groups, kept apart from routes.js so the menu and the permissions context can import
// them without pulling in every page component.
export const adminRoles = ['super_admin', 'admin', 'manager'];
export const otherRoles = ['doctor', 'clinic_owner'];
export const agentRoles = ['agent'];
// Client pages any staff role may open; what they show is then decided per permission
// (users:read, data:*), and the API limits non-admins to their own clients.
export const clientPageRoles = [...adminRoles, ...otherRoles, ...agentRoles];
